import { Injectable } from '@angular/core';
import { SessionIn } from '../interfaces/session-in';


@Injectable({
  providedIn: 'root'
})
export class SessionService {

  public sessionIn: SessionIn = null;
  public token: string = "";
  public revokeToken: string = "";

  constructor() { }

  setSessionValues(body: SessionIn, token: string, revokeToken: string){
    this.sessionIn = body;
    this.token = token;
    this.revokeToken = revokeToken;
    localStorage.setItem('VE9LRU4=', token);
    localStorage.setItem('UkVWT0tFVE9LRU4=', revokeToken);
    localStorage.setItem('U0VTU0lPTl9BRE1JTg==', JSON.stringify(body));
  }

  deletedSession(){
    this.sessionIn = null;
    this.token = "";
    this.revokeToken = "";
    localStorage.removeItem("U0VTU0lPTl9BRE1JTg==");
    localStorage.removeItem("VE9LRU4=");
    localStorage.removeItem("UkVWT0tFVE9LRU4=");
  }

  setSessionValuesStorage(){
    let sessionTemp = localStorage.getItem("U0VTU0lPTl9BRE1JTg==") ? JSON.parse(localStorage.getItem("U0VTU0lPTl9BRE1JTg==")) : null;
    let tokenTemp = localStorage.getItem("VE9LRU4=") ? localStorage.getItem("VE9LRU4=") : '';
    let revokeTokenTemp = localStorage.getItem("UkVWT0tFVE9LRU4=") ? localStorage.getItem("UkVWT0tFVE9LRU4=") : '';
    if(sessionTemp && typeof(sessionTemp) === 'object'){ this.sessionIn = sessionTemp }
    if(tokenTemp && tokenTemp.length > 10){ this.token = tokenTemp }
    if(revokeTokenTemp && revokeTokenTemp.length > 10){ this.revokeToken = revokeTokenTemp }
  }

  get statusSession(){
    this.setSessionValuesStorage();
    return this.sessionIn && this.token.length > 0 && this.revokeToken.length > 0 ? true : false;
  }
}
